import { Component, OnInit } from '@angular/core';
import { OptionRadioModel } from 'src/app/shared/models/common.model';
import { DocumentModel } from 'src/app/shared/models/document.model';
import { ContactModel } from 'src/app/shared/models/contact.model';
import {
  CardTypeModel,
  ProductCard,
} from 'src/app/shared/models/abre-cuentas.model';
import { AbreCuentasService } from 'src/app/shared/services/abre-cuentas/abre-cuentas.service';
import { NavigationService } from 'src/app/shared/services/navigation/navigation-onboarding.service';
import { ChannelCommunicatorService } from 'src/app/shared/services/communicator/channel-communicator/channel-communicator.service';
import { ValidationHelperService } from 'src/app/shared/services/helpers/validation-helper.service';
import { Changes, TagEvent } from 'src/app/shared/models/dali-tags.model';
import { EVENT } from 'src/app/shared/constants/dali.constants';
import { TaggingService } from 'src/app/shared/services/tagging/tagging.service';
import { CopyService } from 'src/app/shared/services/copies/copy.service';
import { HeaderService } from 'src/app/shared/services/header/header.service';
import { ParametersService } from 'src/app/shared/services/parameters/parameters.service';
import { OpEnum } from 'src/app/shared/enums/op.enum';
import { FirmlyApprovedService } from 'src/app/shared/services/firmly-approved/firmly-approved.service';
import { BitacoraService } from 'src/app/shared/services/bitacora/bitacora.service';
import { AdjustEvent } from 'src/app/shared/services/external/adjust/adjust.service';
import { BUSINESS_CONST } from 'src/app/shared/constants/business.constants';
import { callbackAdjustContratarTC } from 'src/app/shared/constants/adjust-callback';
import { OFFERS_STATUS_CONST } from 'src/app/shared/constants/offers-status.constants';

@Component({
  selector: 'app-successful-credit-card-creation',
  templateUrl: './successful-credit-card-creation.component.html',
  styleUrls: ['./successful-credit-card-creation.component.scss'],
})
export class SuccessfulCreditCardCreationComponent implements OnInit {
  selectedProduct: OptionRadioModel;
  documentInfo: DocumentModel;
  infoContact: ContactModel;
  amountPco: string;
  amountAproved: string;
  cardType: CardTypeModel;
  card: ProductCard;
  maxAmount: number;
  amountCard: string;
  restrictAmount: boolean;
  unsuccessfulCreation: boolean;
  percentages: any;
  maskedPhone: string;
  creditCardUses: any;
  creditCardNumber: any;
  productSelected: any;
  postLogin: boolean;

  /**
   * Creates an instance of SuccessfulCreditCardCreationComponent.
   * @param {AbreCuentasService} abreCuentasService
   * @param {AbreCuentasNavigationService} navigationService
   * @memberof SuccessfulCreditCardCreationComponent
   */
  constructor(
    public copyService: CopyService,
    private headerService: HeaderService,
    private abreCuentasService: AbreCuentasService,
    private navigationService: NavigationService,
    private channelCommunicatorService: ChannelCommunicatorService,
    private validationHelperService: ValidationHelperService,
    private taggingService: TaggingService,
    private parameterService: ParametersService,
    private firmlyApprovedService: FirmlyApprovedService,
    private bitacoraService: BitacoraService,
    private adjustEvent: AdjustEvent,
  ) {
    this.headerService.show(false, false, true);
    this.unsuccessfulCreation = false;
    this.creditCardUses = [
      {
        description:
          copyService.copies.successful_credit_card_creation_benefit_1,
      },
      {
        description:
          copyService.copies.successful_credit_card_creation_benefit_2,
      },
      {
        description:
          copyService.copies.successful_credit_card_creation_benefit_3,
      },
    ];
    this.percentages = {
      max: {
        number: 0,
        reached: false,
      },
      halfPlus: {
        number: 0,
        reached: false,
      },
      half: {
        number: 0,
        reached: false,
      },
      quarter: {
        number: 0,
        reached: false,
      },
    };
  }

  ngOnInit() {
    // window.addEventListener('scroll', this.scroll, true);
    // window.scrollTo(0, 0);
    // document.body.scrollTop = 0;
    // document.documentElement.scrollTop = 0;

    this.postLogin = this.abreCuentasService.getPostlogin();
    if (this.postLogin === true) {
      this.navigationService.pageLoadTag(false, ['pv455', '', '', '']);
    } else if (!this.postLogin === true) {
      this.navigationService.pageLoadTag(false, ['pv56', '', '', '']);
    }

    const { selectedProduct } =
      this.abreCuentasService.getPayDayProductSelected();
    this.selectedProduct = selectedProduct;
    this.documentInfo = this.abreCuentasService.getDocumentInfo();
    this.infoContact = this.abreCuentasService.getContactInfo();
    this.cardType = this.abreCuentasService.getCardTypeModel();
    this.productSelected = this.abreCuentasService.getproductSelected();
    if (this.productSelected.product_type === BUSINESS_CONST.PRODUCT_TYPE_TC) {
      const event = {
        eventToken: 'o8o0o1',
        callbackParams: callbackAdjustContratarTC,
      };
      this.adjustEvent.adjustTrackEvent(event);
    }
    this.maskedPhone = this.validationHelperService.maskPhone(
      this.infoContact.mobile_number,
    );
    const pco = this.firmlyApprovedService.isEmpty()
      ? this.abreCuentasService.getPcoModel().granted_product.limit_amount
          .amount
      : this.firmlyApprovedService.getDetailProductsMulti(
          BUSINESS_CONST.PRODUCT_TYPE_TC,
        )[0].limit_amount.amount;
    this.amountPco = (pco + '').replace(/(\d)(?=(\d{3})+(?!\d))/g, '$1.');

    this.card = this.abreCuentasService.getProductCard();
    console.log('CARD', this.card);

    this.card.expiration_date = this.card.expiration_date
      .substring(2, 7)
      .split('-')
      .reverse()
      .join('/');
    this.creditCardNumber = this.card.product_id.replace(/(\d{4})/g, '$1 ');
    this.card.product_id = this.creditCardNumber;
    this.unsuccessfulCreation =
      this.card.solicitation_status.status_code === '04' ? true : false;
    // if (!this.unsuccessfulCreation) {
    //   window.scrollTo(0, 0);
    //   const div = document.getElementById('successful-credit-card')!;
    //   div.scrollIntoView();
    //   div.focus();
    // }

    this.amountCard = (this.card.available_amount.amount + '').replace(
      /(\d)(?=(\d{3})+(?!\d))/g,
      '$1.',
    );

    const configs = this.parameterService.getSetting(
      OpEnum.ABRE_CUENTAS_CONFIGS,
    );
    this.maxAmount = configs['max_creditcard_amount'] || 0;

    this.restrictAmount = pco <= this.maxAmount;
    const amount = this.restrictAmount ? this.amountPco : this.maxAmount;
    this.amountAproved = (amount + '').replace(
      /(\d)(?=(\d{3})+(?!\d))/g,
      '$1.',
    );
    if (!this.firmlyApprovedService.isEmpty()) {
      let product_list: any = [];
      product_list.push(this.productSelected);
      this.firmlyApprovedService.turnOffOffer(
        OFFERS_STATUS_CONST.PRODUCT_ACCEPTED.CODE,
        product_list);
    }
    this.saveBitacoraFirmlyApproved();
  }

  // scroll = (event): void => {
  //   const scrollOffset = event.srcElement.scrollTop;
  //   const DomContainerHeigth = event.srcElement.offsetHeight;
  //   const category = {
  //     module: 'body',
  //     type: 'pagination',
  //     position: 'bottom',
  //   };
  //   const eventNumber = '1';
  //   const action = 'scroll';
  //   const maxScroll = 55;
  //   // 85 is taken as the max scroll because it have a 15% of missed scroll for styles
  //   this.percentages.max.number = 55 * DomContainerHeigth / 100;
  //   this.percentages.halfPlus.number = (75 * maxScroll / 100) * DomContainerHeigth / 100;
  //   this.percentages.half.number = (50 * maxScroll / 100) * DomContainerHeigth / 100;
  //   this.percentages.quarter.number = (25 * maxScroll / 100) * DomContainerHeigth / 100;

  //   if (scrollOffset > this.percentages.max.number && !this.percentages.max.reached) {
  //     this.pageTagEvent(eventNumber, category, action, 'PageViewed100');
  //     this.percentages.max.reached = true;
  //   } else if (scrollOffset >= this.percentages.halfPlus.number && !this.percentages.halfPlus.reached) {
  //     this.pageTagEvent(eventNumber, category, action, 'PageViewed75');
  //     this.percentages.halfPlus.reached = true;
  //   } else if (scrollOffset >= this.percentages.half.number && !this.percentages.half.reached) {
  //     this.pageTagEvent(eventNumber, category, action, 'PageViewed50');
  //     this.percentages.half.reached = true;
  //   } else if (scrollOffset >= this.percentages.quarter.number && !this.percentages.quarter.reached) {
  //     this.pageTagEvent(eventNumber, category, action, 'PageViewed25');
  //     this.percentages.quarter.reached = true;
  //   }
  // }

  /**
   * Opens link to itau page
   *
   * @memberof SuccessfulCreditCardCreationComponent
   */
  openLink() {
    this.channelCommunicatorService
      .getImpl()
      .openExternalBrowser('https://www.itau.co', 5, true);
  }

  /**
   * Summary next step on flow
   *
   * @memberof SuccessfulCreditCardCreationComponent
   */
  next() {
    this.navigationService.nextStep();
  }

  /**
   * @param eventNumber id number of event 1/2/3/4
   * @param category object with properties see eventCategories variable
   * @param customAction action of event click/show
   * @param customLabel custom label
   */
  pageTagEvent(
    eventNumber: string,
    category: any,
    customAction: string,
    customLabel?: string,
  ) {
    const tagPageName = this.navigationService.getCurrentStep().tag_name;
    try {
      const changes: Changes[] = [
        {
          path: EVENT[`${tagPageName}E${eventNumber}setData`][
            `${tagPageName}E${eventNumber}transactionName`
          ].path,
          value:
            EVENT[`${tagPageName}E${eventNumber}setData`][
              `${tagPageName}E${eventNumber}transactionName`
            ].value,
        },
        {
          path: EVENT[`${tagPageName}E${eventNumber}setData`][
            `${tagPageName}E${eventNumber}transactionDetailsProductcategory`
          ].path,
          value:
            EVENT[`${tagPageName}E${eventNumber}setData`][
              `${tagPageName}E${eventNumber}transactionDetailsProductcategory`
            ].value,
        },
      ];
      const event: TagEvent = {
        category: {
          module: EVENT.customCategory.module[category.module],
          type: EVENT.customCategory.type[category.type],
          position: EVENT.customCategory.position[category.position],
        },
        action: EVENT.customAction[customAction],
        label: customLabel
          ? customLabel
          : EVENT[`${tagPageName}E${eventNumber}customLabel`],
      };

      this.taggingService.pageTagEvent(event, changes);
    } catch (error) {
      console.log(error);
    }
  }

  saveBitacoraFirmlyApproved() {
    if (
      !this.firmlyApprovedService.isEmpty() &&
      this.firmlyApprovedService.getOfferType_Channel() === 'En_firme'
    ) {
      const bitacoraEvent = 'offer_aprovedf_ TC';
      this.bitacoraService.saveDataInBitacora(bitacoraEvent);
    }
  }
}
